import { Component, ChangeDetectionStrategy } from '@angular/core';
import { LoginService } from '@services/login.service';
import { Wso2Service } from '@services/wso2.service';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-header-usuario',
    templateUrl: './header-usuario.component.html',
    styleUrls: ['./header-usuario.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass]
})
export class HeaderUsuarioComponent {
  username: string = sessionStorage.username;
  showDropdown = false;

  constructor(
    private readonly wso2Service: Wso2Service,
    private readonly loginService: LoginService
  ) { }

  onClickDropDown(value = !this.showDropdown): void {
    this.showDropdown = value;
  }

  privacidadeESeguranca(): void {
    this.wso2Service.redirectToPrivacidadeESeguranca();
  }

  sairDoSistema() {
    this.loginService.logout();
  }
}
